import { Divider, Stack } from '@mantine/core';

import { ClientHoverCardHeader } from './ClientHoverCardHeader';
import { ClientHoverCardMetrics } from './ClientHoverCardMetrics';

type ClientHoverCardContentProps = {
  debtorId: string;
  debtorName: string;
};

export const ClientHoverCardContent = ({ debtorId, debtorName }: ClientHoverCardContentProps) => (
  <Stack gap="sm" w={400}>
    <ClientHoverCardHeader debtorId={debtorId} debtorName={debtorName} />
    <Divider />
    <ClientHoverCardMetrics debtorId={debtorId} />
  </Stack>
);
